// WHAT: Shared types and context for favorites
// WHY:  Keep React components in .tsx file only for fast-refresh rule

import { createContext } from "react";

/**
 * State interface for favorites context
 *
 * @public
 *
 */
// eslint-disable-next-line import/no-unused-modules -- Reason: This interface is exported for external use and type checking, even if not directly imported in other modules.
export interface FavoritesState {
  /** Array of favorite item IDs */
  favorites: string[];
  /** Function to toggle favorite status of an item */
  toggleFavorite: (id: string) => void;
}

export const FavoritesContext = createContext<FavoritesState | undefined>(undefined);
